import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { isRequired } from 'components/Questionnaires/validators';
import BoxInputField from 'components/Common/Inputs/BoxInputField';

export const QuestionUsTinField = ({ intl, blockId, question, className, disabled, onChange, tinFormat }) => {
  const [inputValue, setInputValue] = useState(question?.answer ?? question.default ?? '');

  const tinMatched = useSelector(state => (state.form?.validationResult?.tinMatched !== undefined ? state.form?.validationResult?.tinMatched : null));

  const onInputChange = (value) => {
    setInputValue(value);
    if (inputValue !== value) {
      onChange(question, value);
    }
    return true;
  };

  const fieldSeperator = useMemo(() => ((tinFormat && tinFormat === 'EIN') ? [1] : [2, 4]), [tinFormat]);

  const getTinBoxClass = () => {
    if (question.isValid === false || tinMatched === false) {
      return ' error';
    }
    return tinMatched === true ? ' success' : '';
  };

  return (<div id={ question.id }>
    <BoxInputField
      key={ `${ blockId }-${ question.id }` }
      id={ `${ blockId }-${ question.id }` }
      name={ question.id }
      className={ `tin-box ${ className } ${ getTinBoxClass() }` }
      disabled={ disabled }
      initialValue={ inputValue }
      callback={ onInputChange }
      fieldLength={ 9 }
      fieldSeperator={ fieldSeperator }
      answerRequired={ isRequired(question) }
      describedby={ `${ question.isValid === false ? (`${ blockId }-${ question.id }-error`) : '' }` }
    />
    { tinMatched === true && <div aria-live="polite" role="alert">
      <FontAwesomeIcon icon="check-circle" color="green" />
      <span> {intl.formatMessage({ id: 'questionnaire.usTin.tin.successMatchMessage' }) }</span>
    </div> }
    { tinMatched === false && <div className="error-container" aria-live="polite" role="alert">
      <FontAwesomeIcon icon="times" className="i-cross mr-4" />
      <span>{ intl.formatMessage({ id: 'questionnaire.usTin.tin.failedMatchErrorMessage' }) }</span>
    </div> }
  </div>);
};

QuestionUsTinField.displayName = 'QuestionUsTinField';

QuestionUsTinField.propTypes = {
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  intl: PropTypes.shape().isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  tinFormat: PropTypes.oneOf(['SSN', 'EIN'])
};

QuestionUsTinField.defaultProps = {
  className: '',
  disabled: false,
  tinFormat: 'SSN'
};

export default QuestionUsTinField;
